import { useTranslation } from "react-i18next";import React, { createContext, useContext, useState, useCallback } from 'react';
import { boardApi, cardApi } from '../services/eztaskApi';

const EzTaskContext = createContext(null);

export const useEzTask = () => {
  const context = useContext(EzTaskContext);
  if (!context) {
    throw new Error('useEzTask must be used within an EzTaskProvider');
  }
  return context;
};

export const EzTaskProvider = ({ children }) => {const { t } = useTranslation("eztask");
  const [boards, setBoards] = useState([]);
  const [currentBoard, setCurrentBoard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBoards = useCallback(async (archived = false) => {
    setLoading(true);
    setError(null);
    try {
      const data = await boardApi.list(archived);
      setBoards(data);
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchBoard = useCallback(async (boardId) => {
    setLoading(true);
    setError(null);
    try {
      const data = await boardApi.get(boardId);
      setCurrentBoard(data);
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const createBoard = useCallback(async (data) => {
    setLoading(true);
    setError(null);
    try {
      const result = await boardApi.create(data);
      await fetchBoards();
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [fetchBoards]);

  const updateBoard = useCallback(async (boardId, data) => {
    try {
      const result = await boardApi.update(boardId, data);
      if (currentBoard?.board_id === boardId) {
        setCurrentBoard((prev) => ({ ...prev, ...data }));
      }
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, [currentBoard]);

  const moveCard = useCallback(async (cardId, targetListId, position) => {
    try {
      await cardApi.move(cardId, targetListId, position);
      if (currentBoard) {
        await fetchBoard(currentBoard.board_id);
      }
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, [currentBoard, fetchBoard]);

  const refreshBoard = useCallback(async () => {
    if (currentBoard) {
      await fetchBoard(currentBoard.board_id);
    }
  }, [currentBoard, fetchBoard]);

  const value = {
    boards,
    currentBoard,
    loading,
    error,
    fetchBoards,
    fetchBoard,
    createBoard,
    updateBoard,
    moveCard,
    refreshBoard,
    setCurrentBoard
  };

  return (
    <EzTaskContext.Provider value={value}>
      {children}
    </EzTaskContext.Provider>);

};